import React from 'react';
import { useHistory } from './useHistory';
import { HeartLoading } from '../../../components/HeartLoading';
import DonationHistory from '../../../components/Donee/components/DonationHistory';
import { Navigate } from 'react-router-dom';
import { ROUTES } from '../../../utils/routes';

export const History: React.FC = () => {
    const { loading, nextPage } = useHistory();

    if (loading) {
        return <HeartLoading maxWidth={300} />;
    }

    if (nextPage === 'HISTORY') {
        return <DonationHistory className={'checkout-grid'} />;
    } else {
        return (
            <Navigate
                to={ROUTES.main}
                state={{ showDownloadModal: true }}
            />
        );
    }
};
